<template>
  <div class="dialog-main">
    <div class="bg-black"></div>
    <div class="Popup">
      <div class="Popup1" :style="{ width: width }">
        <div class="p_title">提示</div>
        <div class="p_content">
          <template v-if="showType === 'text'">
            <p class="p_content-text">{{ text }}</p>
          </template>
          <template v-else-if="showType === 'slot'">
            <slot name="text"></slot>
          </template>
          <template v-else-if="showType === 'timeNode'">
            <p class="p_content-text" v-if="tip">{{ tip }}</p>
            <div class="node-list">
              <div
                v-for="(item, index) in nodeData"
                :class="{
                  'node-item': true,
                  'node-item-gray': onlyShowTime,
                  active: selectNodes[index]
                }"
                :key="index"
                @click="nodeItemClick(index)"
              >
                {{ item.GapDay === 1 ? '次日' : '' }}{{ item.Node }}
              </div>
            </div>
          </template>
        </div>
        <div class="p_content-btm">
          <div class="p_content-btn w_50" v-if="showCancelBtn" @click="cancelClick">{{ cancenBtnText }}</div>
          <div class="p_content-btn w_50 sure" @click="sureClick">{{ sureBtnText }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TimeNodeDialog',
  data() {
    return {
      selectNodes: []
    }
  },
  mounted() {
    this.selectNodes = []
    if (!this.onlyShowTime) {
      this.nodeData.forEach((val) => {
        if (val.IsPrePurchase) {
          this.selectNodes.push(val)
        } else {
          this.selectNodes.push(null)
        }
      })
      // 若仅存在一个未来节点，则默认选中
      if (this.selectNodes[0] === null && this.nodeData.length === 1) {
        this.selectNodes[0] = this.nodeData[0]
      }
    }
    this.nodeData.sort((a, b) => {
      let bNodeTime = b.Node.replace(/(\d{1,2})+[:：](\d*)/gi, '$1')
      let aNodeTime = a.Node.replace(/(\d{1,2})+[:：](\d*)/gi, '$1')
      if (a.GapDay === b.GapDay) {
        return Number(aNodeTime) - Number(bNodeTime)
      } else {
        return a.GapDay - b.GapDay
      }
    })
  },
  props: {
    // 展示类型（text-仅文字，timeNode-时间节点，solt-其它自定义内容）
    showType: {
      type: String,
      default: 'text'
    },
    // 时间节点数据
    nodeData: {
      type: Array,
      default() {
        return []
      }
    },
    // 时间节点只是展示，无点击效果
    onlyShowTime: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '80%'
    },
    // 提示下的说明文字
    tip: {
      type: String,
      default: ''
    },
    sureBtnText: {
      type: String,
      default: '确认'
    },
    cancenBtnText: {
      type: String,
      default: '取消'
    },
    showCancelBtn: {
      type: Boolean,
      default: true
    },
    text: {
      type: String,
      default: ''
    }
  },
  methods: {
    sureClick() {
      let remindTimeOriginal = this.selectNodes.filter((item) => item !== null)
      this.$emit('onConfirm', remindTimeOriginal)
    },
    cancelClick() {
      // this.selectNodes = []
      this.$emit('onCancel')
    },
    close() {
      this.selectNodes = []
      this.$emit('close')
    },
    nodeItemClick(index) {
      if (this.onlyShowTime) return
      if (this.selectNodes[index]) {
        this.$set(this.selectNodes, index, null)
      } else {
        this.$set(this.selectNodes, index, this.nodeData[index])
      }
    },
    dialogTouchMove(e) {
      let className = e.target.className
      if (className !== 'node-item' && className !== 'node-list') {
        e.preventDefault()
      }
    }
  }
  // watch: {
  //   nodeData () {
  //     if (this.nodeData.length > 0) {
  //       this.selectNodes = []
  //       this.nodeData.forEach(item => {
  //         this.selectNodes.push(null)
  //       })
  //     }
  //   }
  // }
}
</script>

<style scoped>
.bg-black {
  width: 100%;
  height: 100%;
  position: fixed;
  background: #000;
  opacity: 0.5;
  top: 0;
  left: 0;
  z-index: 900;
}
.Popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 900;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: dialogAnim 0.2s ease-in;
  animation-fill-mode: backwards;
}
.Popup1 {
  width: 80%;
  background: #fff;
  border-radius: 4px;
  padding: 15px 0 0;
}
.p_title {
  font-size: 16px;
  font-weight: bold;
  text-align: center;
}
.p_content {
  padding: 0 20px;
  margin: 15px 0 15px 0;
  font-size: 15px;
}
.p_content-btm {
  display: flex;
  align-items: center;
  height: 45px;
  margin-top: 10px;
  line-height: 45px;
  font-size: 15px;
  text-align: center;
  border-top: 1px solid #eee;
}
.p_content-btm .p_content-btn {
  flex-grow: 1;
}
.p_content-btm .sure {
  color: #108df1;
  border-left: 1px solid #ddd;
}
.w_50 {
  width: 50%;
}
.feedback-btn {
  color: #108df1;
  cursor: pointer;
}
@keyframes dialogAnim {
  0% {
    opacity: 0;
    transform: scale(0.2);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
/* -----分割线------ */
.node-list {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  max-height: 10.5em;
  overflow: scroll;
}
.node-item {
  height: 30px;
  width: 29%;
  line-height: 30px;
  text-align: center;
  border-radius: 3px;
  border: 1px solid #ccc;
  margin-top: 5%;
  font-size: 14px;
  transition: all 0.2s ease-in;
  margin-right: 13px;
}
.node-item:nth-child(3n) {
  margin-right: 0;
}
.node-item.active {
  border-color: #108df1;
  color: #108df1;
  font-weight: 500;
}
.node-item-gray {
  border: none;
  background: #f2f2f2;
  color: #333;
}
@media screen and (max-width: 320px) {
  .p_content {
    padding: 0 10px;
  }
  .node-list {
    max-height: 8em;
  }
  .node-item {
    width: 30%;
    margin-top: 3%;
    margin-right: 8px;
  }
}
</style>
